// Google Tag Manager bootstrap + Google Consent Mode v2.
//
// On charge GTM en JS au runtime (vs snippet dans index.html) pour :
//   1. Ne pas le charger en dev (VITE_GTM_ID vide)
//   2. Pousser le consent default AVANT que GTM ne fire ses tags
//   3. Garder index.html propre
//
// Loi 25 (QC) : tant que l'utilisateur n'a pas cliqué "Accepter" sur le
// bandeau, tous les storage tracking sont 'denied'. ConsentBanner peut
// ensuite update via updateConsent('granted' | 'denied').

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

type ConsentState = 'granted' | 'denied';

interface ConsentParams {
  ad_storage: ConsentState;
  ad_user_data: ConsentState;
  ad_personalization: ConsentState;
  analytics_storage: ConsentState;
}

// Helper gtag typé — push une commande consent au dataLayer en
// format array, équivalent au `arguments` du snippet officiel Google
// mais sans dépendre de l'AST object (= type-safe).
function gtag(
  command: 'consent',
  action: 'default' | 'update',
  params: ConsentParams,
): void {
  window.dataLayer.push([command, action, params]);
}

function defaultConsent(): ConsentParams {
  return {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  };
}

let initialized = false;

export function initGTM(): void {
  if (initialized) return;
  const id = import.meta.env.VITE_GTM_ID;
  if (!id || typeof id !== 'string' || !id.startsWith('GTM-')) return;

  window.dataLayer = window.dataLayer || [];

  // Consent default DOIT être push AVANT le script GTM, sinon les tags
  // se déclenchent une fois sans connaître le consent state.
  gtag('consent', 'default', defaultConsent());

  // gtm.start ping standard
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(script);

  // Noscript fallback iframe
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

  initialized = true;
}

export function updateConsent(state: ConsentState): void {
  if (!window.dataLayer) window.dataLayer = [];
  const params: ConsentParams = {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  };
  gtag('consent', 'update', params);
}
